import styled from 'styled-components';
import { ScCountdownWidgetCard } from '@/modules/common/components/Countdown/CountdownWidget/styled';
import { reversedGemAnimation } from '@/modules/jackpot/components/JackpotGemsPack/styled';
import { ScTextContentByGroup } from '@/modules/restrictions/components/TextContentByGroup/styled';
import { device } from '@/styles/helpers';
import { typography } from './../../../../styles/helpers';

export const ScWheelPage = styled.div`
  & .bonuses-notice-box {
    position: relative;
    margin-block: -16px 16px;
    width: min(480px, 100%);
    margin-inline: auto;
    z-index: 2;

    @media (${device.mobile}) {
      padding: 0 16px;
    }

    &:empty {
      display: none;
      margin: 0;
    }
  }
  h1 {
    text-align: center;
    margin-bottom: 0;
    text-transform: uppercase;
    ${typography['headline1']}
    margin-bottom: 12px;

    @media (${device.mobile}) {
      font-size: 22px;
      line-height: 28px;
      margin-bottom: 8px;
    }

    & + div {
      max-width: 800px;
      margin: 16px auto;
      text-align: center;
      font-size: 16px;
      line-height: 24px;

      p {
        margin-top: 0;
        color: ${({ theme }) => theme.whiteColor};
      }
    }
  }

  ${ScTextContentByGroup} {
    @media (${device.mobile}) {
      ${typography.body2bold}
    }
  }

  & .header-benefits {
    margin: 8px 0 60px;
    @media (${device.mobile}) {
      margin-top: 0;
    }
  }
`;

export const ScWheelHeader = styled.div`
  position: relative;
  margin-top: -106px;
  padding-top: 96px;
  overflow: hidden;

  @media (${device.mobile}) {
    padding-top: 84px;
    & + div {
      width: calc(100vw - (100vw - 100%));
      overflow-x: hidden;
    }
  }

  ${ScWheelPage}:has(.bonuses-notice-box:not(:empty)) & {
    @media (${device.mobile}) {
      margin-top: -160px;

      .content {
        padding-top: 70px;
        z-index: 1;
      }
    }
  }
  .content {
    position: relative;
    text-align: center;
    z-index: 5;
  }

  .spins-counter-desk {
    position: absolute;
    display: flex;
    left: 50%;
    transform: translateY(-40%) translateX(-50%);
    bottom: 30px;
    align-items: center;
    z-index: 4;
    margin: 0 auto;
    justify-content: center;
    margin-bottom: 8px;
    @media (${device.mobile}) {
      display: none;
    }
  }

  .description {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    @media (${device.mobile}) {
      ${typography.body2regular}
    }
  }

  .countdown-wrapper {
    position: relative;
    width: fit-content;
    margin: 12px auto 0;
    ${ScCountdownWidgetCard} {
      .label {
        font-size: 14px;
        line-height: 14px;
        letter-spacing: 0.42px;
        @media (${device.mobile}) {
          font-size: 12px;
          line-height: 12px;
        }
      }
      .countdown {
        font-size: 20px;
        line-height: 20px;
        letter-spacing: 0.6px;
        @media (${device.mobile}) {
          font-size: 16px;
          line-height: 16px;
        }
      }
    }
    @media (${device.mobile}) {
      margin: 8px auto 0;
    }
  }

  .wheel-stand {
    position: relative;
    display: block;
    transform: translateX(-50%) translateY(-145px);
    left: 50%;
    margin-bottom: -200px;
    object-fit: contain;
    @media (${device.mobile}) {
      position: absolute;
    }
  }

  .spins-counter-mob {
    display: none;
    @media (${device.mobile}) {
      display: flex;
      margin-top: 16px;
      justify-content: center;
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 190px;
    background: linear-gradient(
      0deg,
      rgba(4, 29, 0, 0.64) 0%,
      rgba(4, 29, 0, 0) 100%
    );
    pointer-events: none;
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    display: block;
    width: 100%;
    height: 24px;
    border-radius: 24px 24px 0 0;
    background-color: ${({ theme }) => theme.blackColor};
    z-index: 1;
  }
`;

export const ScWheelHeaderAssets = styled.div`
  display: flex;
  justify-content: center;

  & > img:not(.mobile) {
    position: absolute;
  }

  & > .bg {
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    z-index: -1;
  }

  & > .decor {
    animation: ${reversedGemAnimation} infinite ease-out;
    top: 25%;

    &.left {
      left: calc((100% - 492px) / 4);
      animation-duration: 7s;

      @media (${device.mobile}) {
        /* default state
        width: 160px;
        height: 160px;
        inset: auto -80px 290px auto;
        */
        width: 120px;
        height: 120px;
        inset: auto -20px 260px auto;
      }
    }
    &.right {
      right: calc((100% - 492px) / 3);
      animation-duration: 5s;

      @media (${device.mobile}) {
        width: 112px;
        height: 112px;
        inset: auto auto 56% 8px;
      }
    }
  }

  & > .static {
    bottom: 0;
    @media (${device.mobile}) {
      bottom: 47px;
      position: relative;
    }
    &.left {
      left: 0;
    }
    &.right {
      right: 0;
    }

    &.mobile {
      margin-bottom: -30px;
      z-index: 1;
    }
  }
`;

export const ScWheelContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 64px;
  padding: 0 0 24px;

  @media (${device.mobile}) {
    padding-top: 8px;
  }
`;

export const ScWheelContentSection = styled.div`
  position: relative;
  overflow: hidden;

  & > .center {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -45%);
    z-index: -1;
    @media (${device.mobile}) {
      top: 65%;
    }
  }

  & > img {
    position: absolute;
    pointer-events: none;
    object-fit: none;

    &.left {
      top: -90px;
      left: -75px;
      z-index: -1;
      @media (${device.mobile}) {
        width: 150px;
        height: 267px;
        top: -60px;
        object-fit: cover;
      }
    }

    &.right {
      bottom: -115px;
      right: -105px;
      z-index: -1;
      @media (${device.mobile}) {
        width: 150px;
        height: 267px;
        bottom: 20px;
        right: -50px;
        object-fit: cover;
      }
    }
  }
`;
